export default __webpack_public_path__ + "static/media/soesvinget-property-09.3b6cd781.jpg";